import React from 'react';
import {ToggleProps} from './types';
import {Layout} from '../layout';
import {Icon} from '../icons';
import {OffToggleLayoutMap, OnToggleLayoutMap} from './styles';
import {Spacer} from '..';
import {useAsyncCallback} from '../../hooks';
import {Spinner} from '../spinner';

export const Toggle: React.FC<ToggleProps> = ({on, kind, onPress}) => {
  const onLayout = OnToggleLayoutMap[kind];
  const offLayout = OffToggleLayoutMap[kind];

  const [isSubmitting, handleOnPress] = useAsyncCallback(onPress);

  return (
    <Layout
      width={48}
      height={32}
      centered
      borderRadius={'16'}
      onPress={handleOnPress}
      padding={'4'}
      backgroundColor={
        on ? onLayout.backgroundColor : offLayout.backgroundColor
      }
      borderColor={on ? onLayout.borderColor : offLayout.borderColor}
      borderStyle={on ? undefined : 'solid'}
      borderWidth={on ? undefined : '1'}>
      {isSubmitting ? (
        <Spinner kind={on ? 'Inverse' : 'Primary'} />
      ) : (
        <>
          {on ? (
            <>
              <Icon name={'checkmarkSmall'} inverse size="16" />
              <Layout
                centered
                width={22}
                height={22}
                raised={!(kind === 'Disabled')}
                backgroundColor={onLayout.foregroundColor}
                borderRadius={'9999'}></Layout>
            </>
          ) : (
            <>
              <Layout
                centered
                width={22}
                height={22}
                backgroundColor={offLayout.foregroundColor}
                borderRadius={'9999'}></Layout>
              <Spacer width={'14'}></Spacer>
            </>
          )}
        </>
      )}
    </Layout>
  );
};
